export const environment = {
  msalConfig: {
    auth: {
      clientId: '53d7e4e8-b52b-49a5-b87d-cff0afacf369',
      authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
      redirectUri: 'https://wwwqa.wings.ford.com/'
    }
  },
  apiConfig: {
    scopes: ['api://b5dab151-905b-4c52-bcdc-04ea9dcfcd34/webapp'],
    uri: 'https://www.apitestqa.jab7.wings.ford.com/WingsREST/api/',
  },
  production: false,
  serviceUrl: "https://www.apitestqa.jab7.wings.ford.com/WingsREST/api/",
  wingsBackendUrl: 'https://api-qat.int.service.ford.com/wingsApiBackend',
  angularFrontend: "https://angularqa.wings.ford.com/#/",
  simulationUrl: "https://simulationqa.wings.ford.com/api/v1/",
  chatAgentUrl: "https://api-qat.int.service.ford.com/wingsKnowledgeAgent",
  chatAdkUrl: "https://api-qat.int.service.ford.com/WingsADK",
  outboundFrontend: "https://wings-outbound-frontend-qa-619078306104.us-central1.run.app/",
  outboundBackend: "https://api-qat.int.service.ford.com/wingsOutbound",
  backofficeFrontend: "https://wings-backoffice-frontend-qa-619078306104.us-central1.run.app/",
  backofficeBackend: "https://api-qat.int.service.ford.com/wingsBackoffice",
  claimFrontend: "https://wwwqa.wings-claim.ford.com/"
};
